import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'
import qs from 'qs'
import jwt_decode from "jwt-decode";


import {
    SIGNIN_ACTION,
    SUBMIT_REGISTRATION,
    submitregistrationSuccessful,
    startLoading,
    stopLoading,
    currentUser,
    signinStatus,
    registrationStatus,
    RESET_PASSWORD,
    resetPasswordSuccessful,
    CHANGE_PASSWORD,
    changePasswordSuccessful,
    VALIDATE_TOKEN,
    hasValidatedToken,
    ACTIVATE_EMAIL,
    ACTIVATE_MEMBER_ACCOUNT,
    hasActivatedMemberAccount,
    hasActivatedEmail
} from '../actions'

import {
    REGISTRATION_LOADING_ID,
    SIGNIN_LOADING_ID,
    RESET_PASSWORD_LOADING_ID,
    CHANGE_PASSWORD_LOADING_ID
} from '../store/loaders'



function * signinSaga (paylaod){
    const data = {
        username: paylaod.data.phoneNumber,
        password: paylaod.data.password,
        grant_type: process.env.REACT_APP_KEYCLOACK_GRANT_TYPE,
        client_id: process.env.REACT_APP_KEYCLOACK_CLIENT_ID,
        client_secret: process.env.REACT_APP_KEYCLOACK_CLIENT_SECRET_KEY,
        scope: process.env.REACT_APP_KEYCLOACK_SCOPE,
      };
      yield put(startLoading({id:SIGNIN_LOADING_ID}))
    try{
       const response=  yield call(DCore.post, 
        'keycloack',qs.stringify(data), {
            "Content-Type": "application/x-www-form-urlencoded",
            'Authorization': `Bearer`
        })
        yield put(stopLoading({id:SIGNIN_LOADING_ID}))
        localStorage.setItem("Token", response.data.access_token);
        const decode =  jwt_decode(response.data.access_token)
        yield put(currentUser(decode))

    }catch(e){
        yield put(stopLoading({id:SIGNIN_LOADING_ID}))
        console.log("some thing went wrong", e)
        yield put(signinStatus(e.response))
    }
}


function * submitRegistration (paylaod){
    yield put(startLoading({id: REGISTRATION_LOADING_ID}))
        delete paylaod.data.firmInputs.confirmPassword
    try{
       const response=  yield call(DCore.post, '/users/api/v1/users',{
        ...paylaod.data.firmInputs,
       },{
        "Content-Type": "application/json",
        'Authorization': `Bearer`
       })
        yield put(stopLoading({id: REGISTRATION_LOADING_ID}))
        yield put (submitregistrationSuccessful(response.data))

    }catch(e){
        yield put(stopLoading({id: REGISTRATION_LOADING_ID}))
        yield put(registrationStatus(e.response))
        console.log("some thing went wrong", e)
    }
}


function * resetPassword (payload){
    yield put(startLoading({id:RESET_PASSWORD_LOADING_ID}))

    try{
        const response = yield call(DCore.get,`/users/api/v1/users/recover-password/${payload.data}`)
        yield put(stopLoading({id:RESET_PASSWORD_LOADING_ID}))
        yield put (resetPasswordSuccessful(response.data))
    }
    catch(e){
        yield put(stopLoading({id:RESET_PASSWORD_LOADING_ID}))
        console.log(e.response)
    }
}

function * activateEmail (payload){

    try{
        const response = yield call(DCore.get,`/users/api/v1/users/activate/${payload.data}`)
        yield put(hasActivatedEmail(response.data))
    }
    catch(e){
        console.log(e.response)
    }
}


function * changePassword (payload){
    yield put(startLoading({id: CHANGE_PASSWORD_LOADING_ID}))
    try{
        const response = yield call(DCore.post, `/users/api/v1/users/password/reset`, { 
            "newPassword": payload.data.password,
            "token": payload.data.token})
        yield put(changePasswordSuccessful(response.data))
    }
     catch(e){

     }
}


function * validateTokenSaga (payload){
    yield put(startLoading({id: CHANGE_PASSWORD_LOADING_ID}))
    try{
        const response = yield call(DCore.get, `/users/api/v1/users/token/validate/${payload.data}`)
        yield put(hasValidatedToken(response.data))
    }
     catch(e){

     }
}

function * activateMemberAccount (payload){
    yield put(startLoading({id: CHANGE_PASSWORD_LOADING_ID}))
    try{
        const response = yield call(DCore.get, `/users/api/v1/users/members/activate/${payload.data}`)
        yield put(hasActivatedMemberAccount(response.data))
    }
     catch(e){

     }
}


export function * authSaga(){
    yield takeLatest(SIGNIN_ACTION, signinSaga)
    yield takeLatest(SUBMIT_REGISTRATION,submitRegistration)
    yield takeLatest(RESET_PASSWORD,resetPassword)
    yield takeLatest(ACTIVATE_EMAIL,activateEmail)
    yield takeLatest(VALIDATE_TOKEN,validateTokenSaga)
    yield takeLatest(CHANGE_PASSWORD,changePassword)
    yield takeLatest(ACTIVATE_MEMBER_ACCOUNT,activateMemberAccount)
}